import './axios'
import './fontawesome'
import './hotkey'
import './serverTable'
import './misc'
import 'bootstrap'

window.pflt = function (num) {
    return parseFloat(num) || 0
}
